import type { RequestType, RequestStatus, RequestPriority } from '../types/models.js';

export const REQUEST_TYPES: Record<RequestType, {
  label: string;
  description: string;
  color: string;
  bgColor: string;
  icon: string;
}> = {
  idea: {
    label: 'Idea',
    description: 'A new concept or suggestion',
    color: '#f59e0b',
    bgColor: 'rgba(245, 158, 11, 0.1)',
    icon: 'lightbulb',
  },
  feature: {
    label: 'Feature',
    description: 'A specific functionality request',
    color: '#8b5cf6',
    bgColor: 'rgba(139, 92, 246, 0.1)',
    icon: 'sparkles',
  },
  bug: {
    label: 'Bug',
    description: 'An issue or problem to fix',
    color: '#ef4444',
    bgColor: 'rgba(239, 68, 68, 0.1)',
    icon: 'bug',
  },
};

export const REQUEST_STATUSES: Record<RequestStatus, {
  label: string;
  description: string;
  color: string;
  bgColor: string;
  icon: string;
}> = {
  new: {
    label: 'New',
    description: 'Newly submitted request',
    color: '#3b82f6',
    bgColor: 'rgba(59, 130, 246, 0.1)',
    icon: 'inbox',
  },
  under_review: {
    label: 'Under Review',
    description: 'Being reviewed by team',
    color: '#f59e0b',
    bgColor: 'rgba(245, 158, 11, 0.1)',
    icon: 'eye',
  },
  plan_proposed: {
    label: 'Plan Proposed',
    description: 'Awaiting client approval of plan',
    color: '#8b5cf6',
    bgColor: 'rgba(139, 92, 246, 0.1)',
    icon: 'file-text',
  },
  approved: {
    label: 'Approved',
    description: 'Plan approved, ready for work',
    color: '#10b981',
    bgColor: 'rgba(16, 185, 129, 0.1)',
    icon: 'check-circle',
  },
  converted: {
    label: 'Converted',
    description: 'Converted to work item',
    color: '#06b6d4',
    bgColor: 'rgba(6, 182, 212, 0.1)',
    icon: 'arrow-right-circle',
  },
  declined: {
    label: 'Declined',
    description: 'Request was declined',
    color: '#ef4444',
    bgColor: 'rgba(239, 68, 68, 0.1)',
    icon: 'x-circle',
  },
  archived: {
    label: 'Archived',
    description: 'No longer active',
    color: '#9ca3af',
    bgColor: 'rgba(156, 163, 175, 0.1)',
    icon: 'archive',
  },
};

export const REQUEST_PRIORITIES: Record<RequestPriority, {
  label: string;
  color: string;
  bgColor: string;
  icon: string;
}> = {
  low: {
    label: 'Low',
    color: '#6b7280',
    bgColor: 'rgba(107, 114, 128, 0.1)',
    icon: 'arrow-down',
  },
  medium: {
    label: 'Medium',
    color: '#f59e0b',
    bgColor: 'rgba(245, 158, 11, 0.1)',
    icon: 'minus',
  },
  high: {
    label: 'High',
    color: '#f97316',
    bgColor: 'rgba(249, 115, 22, 0.1)',
    icon: 'arrow-up',
  },
  critical: {
    label: 'Critical',
    color: '#ef4444',
    bgColor: 'rgba(239, 68, 68, 0.1)',
    icon: 'alert-triangle',
  },
};

export const REQUEST_STATUS_FLOW: Record<RequestStatus, RequestStatus[]> = {
  new: ['under_review', 'declined', 'archived'],
  under_review: ['new', 'plan_proposed', 'declined', 'archived'],
  plan_proposed: ['under_review', 'approved', 'declined'],
  approved: ['under_review', 'converted', 'archived'],
  converted: ['archived'],
  declined: ['new', 'archived'],
  archived: ['new'],
};
